import { useMsal } from '@azure/msal-react';

export const useIsAdmin = () => {
  const { accounts } = useMsal();
  const roles = accounts[0].idTokenClaims?.roles;

  if (roles === undefined) return false;
  if (roles.includes('PEPM.Admin')) return true;

  return false;
};
